/** Imports */
import {type tFunction} from '@/types/utils';
import {type TikTokPostSettings} from '@/mongoSchemas/Post/Posts.zod';
import {postCreatorFeedbackMessage, type PostCreatorFeedbackMessage} from '@/modules/postCreatorFeedback';


/** Helpers */
export function getTikTokSettingsErrorMessages(
    t: tFunction,
    settings: TikTokPostSettings | undefined,
): Array<PostCreatorFeedbackMessage> {
    const errors: Array<PostCreatorFeedbackMessage> = [];

    if (!settings?.tiktokCreatorInfo) {
        errors.push(postCreatorFeedbackMessage(t('tiktokCreatorInfoError'), 'tiktok'));
        return errors;
    }
    if (settings.postAsDraft) {
        return errors;
    }
    if (!settings.visibility) {
        errors.push(postCreatorFeedbackMessage(t('tiktokSelectVisibility'), 'tiktok'));
    }
    if (settings.discloseContent && (!settings.discloseContent_brandContent && !settings.discloseContent_brandOrganic)) {
        errors.push(postCreatorFeedbackMessage(t('tiktokDisclosureRequired'), 'tiktok'));
    }
    if (settings.discloseContent && settings.discloseContent_brandContent && (settings.visibility === 'SELF_ONLY')) {
        errors.push(postCreatorFeedbackMessage(t('tiktokDisclosureNotAllowed'), 'tiktok'));
    }

    return errors;
}
